module.exports = __webpack_public_path__ + "static/media/sis-transmission.fed57074.png";